
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-buy/watch-buyers-nyc",
      function () {
        return require("private-next-pages/what-we-buy/watch-buyers-nyc/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-buy/watch-buyers-nyc"])
      });
    }
  